import React, { memo } from 'react';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Box, Image } from '@chakra-ui/react';
import SubRequiredIcon from '../../../global/styles/images/sub-required-icon.svg'

function ProAccountNeededIcon({paidFeatureAccess}) {
  // UUU hover shows description
  if (!paidFeatureAccess) {
   return (
    <Box as='span'>
      <Image src={SubRequiredIcon} boxSize='1em' />
    </Box>
   )
  } else return null;
}


const mapStateToProps = (state) => ({
  paidFeatureAccess: state.userPrivileges.results.paidFeatureAccess
})


export default memo(withRouter(connect(mapStateToProps, null)(ProAccountNeededIcon)))